export default {
  DisableOverlay: 'rfp-storelocator-disable-overlay',
  StoresFound: 'rfp-stores-found',
};
